<script setup>
import Clips from "@components/explore/Clips.vue";
import CountryInfo from "@components/explore/CountryInfo.vue";
import Questions from "@components/explore/Questions.vue";
import ToggleControls from "@components/explore/ToggleControls.vue";
</script>

<template>
    <div class="contents">
        <Clips />
        <CountryInfo />
        <Questions />
        <ToggleControls />
    </div>
</template>